const SET_PROFILE = "SET_PROFILE";
const CLEAR_STATE = "CLEAR_STATE";
const SET_CONTENTS = "SET_CONTENTS";

export { SET_PROFILE, CLEAR_STATE, SET_CONTENTS };
